import { FEATURES } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { CustomView, toCustomView } from '../../dataObjects/CustomView';

export interface IDeleteCustomViewsRequest extends IBaseRequest {

}

export class DeleteCustomViewsRequest extends BaseRequest implements IDeleteCustomViewsRequest {

  public CUSTOM_VIEWS: CustomView[];

  constructor(server: string, session: string, CUSTOM_VIEWS: CustomView[]) {
    super(server, session);
    this.CUSTOM_VIEWS = CUSTOM_VIEWS;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    if(this.CUSTOM_VIEWS) {
        for(let customView of this.CUSTOM_VIEWS) {
            parameters += toCustomView(customView);
        }
    }
    return super.wrapperXml(FEATURES.deleteCustomViews, parameters);
  }
}
